import {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import { getRequest } from "services/api";
import { buildQueryString } from "utils/queryHelpers";

const GuideContext = createContext();

export const GuideProvider = ({ children }) => {
  const [guides, setGuides] = useState({
    data: [],
    pagination: null,
    error: null,
    loading: false,
  });

  const [filterOptions, setFilterOptions] = useState({
    search: "",
    currentPage: 1,
    totalPages: 1,
  });

  const queryString = buildQueryString({
    search: filterOptions.search || "",
    page: filterOptions.currentPage,
    limit: 100,
    orderBy: "name",
    sort: "asc",
  });

  const handleSearch = (e) => {
    if (e.key === "Enter") {
      console.log("search", e.target.value);
      setFilterOptions((prevState) => ({
        ...prevState,
        search: e.target.value,
      }));
    }
  };

  const fetchGuides = useCallback(async () => {
    setGuides((prevState) => ({
      ...prevState,
      loading: true,
    }));

    try {
      const response = await getRequest(`/guide${queryString}`);
      if (response.success) {
        setGuides({
          data: response.data,
          pagination: response.pagination,
          error: null,
          loading: false,
        });
      }
    } catch (error) {
      setGuides((prevState) => ({
        ...prevState,
        error: "Failed to fetch guides",
        loading: false,
      }));
    }
  }, [queryString]);

  useEffect(() => {
    fetchGuides();
  }, [fetchGuides]);

  return (
    <GuideContext.Provider
      value={{ guides, handleSearch, filterOptions, refetch: fetchGuides }}
    >
      {children}
    </GuideContext.Provider>
  );
};

export const useGuide = () => {
  const context = useContext(GuideContext);
  if (!context) {
    throw new Error("useGuide must be used within GuideProvider");
  }
  return context;
};
